<div class="thresholds-list-container">

    <div class="thresholds-list">
        <mat-nav-list [disableRipple]="true">
            <a mat-list-item *ngFor="let item of thresholds;"
               (click)="onThresholdSelection(item)" [ngClass]="{'active': item === selectedThreshold}">
                <div class="threshold-item">
                    <div class="threshold-item-name" [title]="item.name">{{item.name}}</div>
                    <div class="threshold-item-icons">
                        <mat-icon *ngIf="item.totalAlerts" [matBadge]="item.totalAlerts">notifications_none</mat-icon>
                        <mat-icon *ngIf="!item.id">save</mat-icon>
                    </div>
                </div>
            </a>
        </mat-nav-list>
    </div>
</div>
